<template>
  <Menu v-if="$store.state.availableLocales.length > 1" as="div" class="ml-3 relative" v-slot="{ open }">
    <div>
      <MenuButton
        class="focus-ring-opposite flex text-opposite-500 text-sm rounded-full p-1"
        data-cy="language-button"
        aria-haspopup="true"
        :aria-expanded="open ? 'true' : 'false'"
        :aria-controls="'languages-menu-items'"
      >
        <span class="sr-only">{{ $t('header.openLanguageMenu') }}</span>
        <span class="block sm:hidden">{{ currentLanguage.shortName }} </span>
        <span class="sm:block hidden">{{ currentLanguage.longName }} </span>
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems id="languages-menu-items" class="profile-menu" data-cy="languages-menu">
        <MenuItem v-for="lang in $store.state.availableLocales" :key="lang.code" v-slot="{ active }">
          <a
            :data-cy="'language-' + lang.code"
            @click="changeLanguage(lang.code)"
            class="focus-ring-primary block px-4 py-2 text-sm text-gray-700 cursor-pointer"
            :class="[$i18n.locale === lang.code ? 'text-primary-700' : '', active ? 'bg-primary-100 text-primary-900' : '']"
          >
            {{ lang.longName }}
          </a>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
  <span>
    <!--
    Keep this empty span here, it's a long story:
    _withScopeId is not called when we don't have elements that should be hoisted to some scope thingy by vue.
    So we need to keep this span here, otherwise the coverage report will be missing some function calls.
    (keywords: _withScopeId, HOISTED, #__PURE__, Code coverage, ...)
    -->
  </span>
</template>

<script lang="ts" src="./language-dropdown.component.ts" />

<style lang="less" scoped>
@tailwind components;
@layer components {
  .profile-menu {
    @apply absolute p-1 ltr:right-0 rtl:left-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none;
  }
}
</style>
